import { render } from "./CustomerServicePage.vue?vue&type=template&id=05288680&scoped=true"
import script from "./CustomerServicePage.vue?vue&type=script&lang=js"
export * from "./CustomerServicePage.vue?vue&type=script&lang=js"

import "./CustomerServicePage.vue?vue&type=style&index=0&id=05288680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05288680"]])

export default __exports__